export const fallbackServices = [
  {
    id: "f1",
    slug: "koruma-ve-guvenlik",
    icon: "Shield",
    title_tr: "Koruma ve Güvenlik",
    title_en: "Security & Protection",
    title_it: "Sicurezza e Protezione",
    summary_tr: "Her biri kendi konusunda uzman, profesyonel kadrosuyla güvenlikte mükemmelliği sağlıyoruz.",
    summary_en: "Excellence in security with our certified, professional team.",
    summary_it: "Eccellenza nella sicurezza con il nostro team di esperti certificati e professionali.",
    content_tr: `Anadolu Terra, 2004'ten bu yana 5188 sayılı Özel Güvenlik Hizmetlerine Dair Kanun kapsamında özel güvenlik hizmetleri sunmaktadır. Konut siteleri, plazalar, AVM'ler, hastaneler, fabrikalar ve etkinlik alanlarında silahlı ve silahsız güvenlik personeli, devriye, kontrol ve danışmanlık hizmetlerimizle 7/24 koruma sağlıyoruz.

## Hizmet Kapsamımız

- Sabit nokta güvenliği (giriş–çıkış, lobi, otopark, danışma)
- Mobil ve yaya devriye hizmetleri
- VIP koruma ve yakın koruma
- Etkinlik, organizasyon ve fuar güvenliği
- Risk analizi, güvenlik etüdü ve danışmanlık
- Acil durum ve kriz yönetimi planlaması

## Özel Güvenlik Hizmeti Ne Sağlar?

Özel güvenlik, 5188 sayılı kanunla düzenlenen ve İçişleri Bakanlığı denetiminde yürütülen, kamu kolluk kuvvetlerinden bağımsız bir koruma modelidir. Anadolu Terra'nın özel güvenlik ekibi resmi kimlik kartlı, eğitimli personelden oluşur; konut sitesi, plaza, AVM, hastane, fabrika ve etkinlik alanlarında sabit nokta, devriye, VIP koruma ve etkinlik güvenliği hizmetlerini kapsar. İhtiyacınıza özel özel güvenlik planlaması için [teklif alın](https://anadoluterra.com/teklif-iste).

## Personel Niteliklerimiz

Tüm güvenlik görevlilerimiz İçişleri Bakanlığı onaylı özel güvenlik temel eğitimini tamamlamış, kimlik kartına sahip ve düzenli yenileme eğitiminden geçmektedir. İlk yardım, yangın güvenliği ve müşteri ilişkileri eğitimleri standart programımızın parçasıdır.

## Operasyonel Standartlar

Sahada akıllı devriye sistemleri (QR/NFC kontrol noktaları), günlük vardiya raporları ve aylık operasyon raporlarıyla denetlenebilir bir hizmet sunuyoruz. Bölge yöneticilerimiz haftalık saha ziyaretleriyle hizmet kalitesini denetler; tespit edilen aksaklıklar 24 saat içinde düzeltici aksiyon planına bağlanır.

## Anadolu Yakası Özel Güvenlik Hizmet Bölgelerimiz

İstanbul **Anadolu Yakası merkezli** bir özel güvenlik firması olarak Kadıköy, Ataşehir, Ümraniye, Üsküdar, Maltepe, Kartal, Pendik, Tuzla, Sancaktepe, Çekmeköy, Beykoz, Sultanbeyli ve Şile başta olmak üzere tüm Anadolu Yakası'nda saha ekiplerimizle 7/24 hizmet veriyoruz. Bölge müdürlüğümüz ve mobil ekip konumlandırmamız sayesinde Anadolu Yakası içindeki taleplere ortalama 30 dakika içinde saha müdahalesi sağlıyoruz. Anadolu Yakası'nda 300'ü aşkın konut sitesi, plaza ve tesiste aktif güvenlik operasyonu yürütüyoruz.

## Neden Anadolu Terra?

20 yılı aşkın saha deneyimi, 1000+ kişilik kadro ve İstanbul Anadolu Yakası başta olmak üzere Türkiye geneline uzanan operasyon ağıyla farklı sektörlerin güvenlik ihtiyaçlarına özel çözümler üretiyoruz. Müşterilerimize tek elden entegre tesis hizmetleri sunabilme avantajıyla güvenlik, temizlik, taşıma ve teknik bakım operasyonlarını tek sözleşme altında yönetebiliyorsunuz.`,
    content_en: `Since 2004, Anadolu Terra has provided private security services under Turkey's Law No. 5188 on Private Security Services. We deliver 24/7 protection — armed and unarmed personnel, patrols, control and consulting — for residences, plazas, malls, hospitals, factories and event venues.

## Scope of Service

- Static-post security (entry/exit, lobby, parking, reception)
- Mobile and foot patrol
- VIP and close protection
- Event, organization and exhibition security
- Risk analysis, security audit and consulting
- Emergency and crisis management planning

## Personnel Standards

All officers have completed the Ministry of Interior-approved private-security training, hold valid ID cards and undergo regular refresher training. First aid, fire safety and customer-service training are part of our standard program.

## Operational Standards

Smart patrol systems (QR/NFC checkpoints), daily shift reports and monthly operations reports keep our service fully auditable. Regional managers visit sites weekly; any issue is mapped to a corrective action within 24 hours.

## Why Anadolu Terra

Over 20 years of field experience, a 1000+ workforce and a nationwide operations network — combined with integrated facility services available under a single contract.`,
    content_it: `Dal 2004, Anadolu Terra eroga servizi di sicurezza privata ai sensi della Legge turca n. 5188 sui Servizi di Sicurezza Privata. Forniamo protezione 24/7 — personale armato e non armato, pattugliamenti, controlli e consulenza — per residenze, plazas, centri commerciali, ospedali, fabbriche e sedi di eventi.

## Ambito del Servizio

- Sicurezza a posto fisso (ingresso/uscita, hall, parcheggio, reception)
- Pattugliamento mobile e a piedi
- Protezione VIP e close protection
- Sicurezza per eventi, organizzazioni e fiere
- Analisi dei rischi, audit di sicurezza e consulenza
- Pianificazione di emergenza e gestione delle crisi

## Standard del Personale

Tutti gli operatori hanno completato la formazione di sicurezza privata approvata dal Ministero dell'Interno, possiedono tessera identificativa valida e seguono corsi di aggiornamento periodici. Primo soccorso, sicurezza antincendio e formazione al servizio clienti fanno parte del nostro programma standard.

## Standard Operativi

Sistemi di pattugliamento intelligente (checkpoint QR/NFC), report di turno giornalieri e report operativi mensili rendono il servizio pienamente tracciabile. I responsabili di area visitano i siti settimanalmente; ogni anomalia rilevata viene associata a un piano correttivo entro 24 ore.

## Perché Anadolu Terra

Oltre 20 anni di esperienza sul campo, una forza lavoro di oltre 1000 persone e una rete operativa nazionale — uniti a servizi integrati di facility disponibili in un unico contratto.`,
    title_de: "Sicherheits- und Schutzdienste",
    summary_de: "Exzellenz im Sicherheitsbereich durch unser zertifiziertes, professionelles Team.",
    content_de: `Seit 2004 erbringt Anadolu Terra private Sicherheitsdienstleistungen gemäß dem türkischen Gesetz Nr. 5188 über private Sicherheitsdienste. Wir bieten 24/7-Schutz — bewaffnetes und unbewaffnetes Personal, Streifen, Kontroll- und Beratungsdienste — für Wohnanlagen, Büroplexe, Einkaufszentren, Krankenhäuser, Fabriken und Veranstaltungsorte in Istanbul und ganz Turkey.

## Leistungsumfang

- Stationärer Sicherheitsdienst (Ein-/Ausgang, Empfang, Parkplatz, Rezeption)
- Mobile und fußläufige Streifen
- VIP- und Personenschutz
- Sicherheit bei Veranstaltungen, Messen und Ausstellungen
- Risikoanalyse, Sicherheitsaudit und Beratung
- Notfall- und Krisenmanagementplanung

## Personalstandards

Alle Sicherheitsbeamten haben die vom türkischen Innenministerium genehmigte Sicherheitsgrundausbildung abgeschlossen, besitzen gültige Ausweise und absolvieren regelmäßig Fortbildungen. Erste Hilfe, Brandschutz und Kundenbetreuung sind fester Bestandteil unseres Standardprogramms.

## Operative Standards

Intelligente Streifsysteme (QR/NFC-Kontrollpunkte), tägliche Schichtberichte und monatliche Betriebsberichte machen den Service vollständig nachvollziehbar. Gebietsleiter besuchen Standorte wöchentlich; jedes Problem wird innerhalb von 24 Stunden einem Korrekturplan zugeordnet.

## Warum Anadolu Terra?

Über 20 Jahre Felderfahrung, eine Belegschaft von über 1.000 Mitarbeitern und ein landesweites Betriebsnetz — kombiniert mit integrierten Facility-Dienstleistungen unter einem einzigen Vertrag.`,
    title_es: "Seguridad y Protección",
    summary_es: "Excelencia en seguridad con nuestro equipo profesional y certificado.",
    content_es: `Desde 2004, Anadolu Terra presta servicios de seguridad privada bajo la Ley turca n.º 5188 sobre Servicios de Seguridad Privada. Ofrecemos protección 24/7 — personal armado y desarmado, patrullas, control y consultoría — para residencias, plazas, centros comerciales, hospitales, fábricas y espacios para eventos en Estambul y toda Turquía.

## Alcance del Servicio

- Seguridad en punto fijo (entrada/salida, vestíbulo, aparcamiento, recepción)
- Patrullas móviles y a pie
- Protección VIP y de escolta personal
- Seguridad en eventos, organizaciones y ferias
- Análisis de riesgos, auditoría de seguridad y consultoría
- Planificación de emergencias y gestión de crisis

## Estándares de Personal

Todos los oficiales han completado la formación de seguridad privada aprobada por el Ministerio del Interior, poseen credenciales válidas y realizan formación de reciclaje periódica. Primeros auxilios, seguridad contra incendios y atención al cliente forman parte de nuestro programa estándar.

## Estándares Operativos

Sistemas de patrulla inteligentes (puntos de control QR/NFC), informes de turno diarios e informes mensuales de operaciones hacen que el servicio sea completamente auditable. Los gestores regionales visitan los emplazamientos semanalmente; cualquier incidencia se vincula a un plan de acción correctiva en 24 horas.

## ¿Por qué Anadolu Terra?

Más de 20 años de experiencia en campo, una plantilla de más de 1.000 empleados y una red operativa nacional — combinados con servicios integrales de gestión de instalaciones en un único contrato.`,
    title_ru: "Охрана и Безопасность",
    summary_ru: "Профессиональная охрана высочайшего уровня с сертифицированным персоналом.",
    content_ru: `С 2004 года Anadolu Terra оказывает услуги частной охраны в соответствии с турецким Законом № 5188 об услугах частной охраны. Мы обеспечиваем круглосуточную защиту — вооружённый и невооружённый персонал, патрулирование, контроль и консультации — для жилых комплексов, бизнес-центров, торговых центров, больниц, заводов и площадок для проведения мероприятий в Стамбуле и по всей Турции.

## Спектр услуг

- Охрана стационарных постов (входы/выходы, лобби, парковка, ресепшн)
- Мобильное и пешее патрулирование
- VIP-охрана и личная охрана
- Охрана мероприятий, выставок и конференций
- Анализ рисков, аудит безопасности и консультации
- Планирование действий в чрезвычайных ситуациях и управление кризисами

## Стандарты персонала

Все сотрудники охраны прошли подготовку, одобренную Министерством внутренних дел Турции, имеют действительные удостоверения и регулярно проходят переподготовку. Первая помощь, пожарная безопасность и обслуживание клиентов являются обязательными элементами нашей программы.

## Операционные стандарты

Системы умного патрулирования (контрольные точки QR/NFC), ежедневные отчёты по сменам и ежемесячные операционные отчёты обеспечивают полную прозрачность сервиса. Региональные менеджеры еженедельно посещают объекты; каждое нарушение в течение 24 часов получает план корректирующих действий.

## Почему Anadolu Terra?

Более 20 лет полевого опыта, штат свыше 1000 сотрудников и общенациональная операционная сеть — в сочетании с комплексными услугами управления объектами по единому договору.`,
    title_fr: "Sécurité et Protection",
    summary_fr: "Excellence en sécurité grâce à notre équipe professionnelle et certifiée.",
    content_fr: `Depuis 2004, Anadolu Terra fournit des services de sécurité privée en vertu de la Loi turque n° 5188 sur les services de sécurité privée. Nous assurons une protection 24h/24 — personnel armé et non armé, patrouilles, contrôle et conseil — pour des résidences, des complexes de bureaux, des centres commerciaux, des hôpitaux, des usines et des lieux d'événements à Istanbul et dans toute la Turquie.

## Périmètre des Services

- Sécurité à poste fixe (entrée/sortie, hall, parking, réception)
- Patrouilles mobiles et à pied
- Protection VIP et rapprochée
- Sécurité lors d'événements, d'organisations et de foires
- Analyse des risques, audit de sécurité et conseil
- Planification des urgences et gestion de crise

## Standards du Personnel

Tous les agents ont suivi la formation en sécurité privée approuvée par le ministère de l'Intérieur, détiennent des cartes d'identification valides et suivent des formations de recyclage régulières. Les premiers secours, la sécurité incendie et le service client font partie de notre programme standard.

## Standards Opérationnels

Des systèmes de patrouille intelligents (points de contrôle QR/NFC), des rapports de quart quotidiens et des rapports d'exploitation mensuels rendent le service entièrement traçable. Les responsables régionaux visitent les sites chaque semaine ; tout problème est associé à un plan d'action correctif dans les 24 heures.

## Pourquoi Anadolu Terra ?

Plus de 20 ans d'expérience terrain, un effectif de plus de 1 000 personnes et un réseau opérationnel national — combinés à des services intégrés de gestion des installations sous un contrat unique.`,
    image_url: null,
  },
  {
    id: "f2",
    slug: "zirhli-arac-ve-tasima",
    icon: "Truck",
    title_tr: "Zırhlı Araç Tahsisi ve Taşıma",
    title_en: "Armored Vehicle Allocation & Secure Transport",
    title_it: "Veicoli Blindati e Trasporto Sicuro",
    summary_tr: "Kıymet nakli, VIP araç tahsisi ve kritik yük taşımada güvenlik disiplinini yola taşıyoruz.",
    summary_en: "Valuables transport, VIP vehicle allocation and critical cargo movement under a security discipline.",
    summary_it: "Trasporto valori, assegnazione veicoli VIP e movimentazione di carichi critici con disciplina di sicurezza.",
    content_tr: `Anadolu Terra, 2004'ten bu yana yürüttüğü özel güvenlik operasyonlarındaki saha disiplinini zırhlı araç tahsisi ve güvenli taşıma hizmetlerine taşımaktadır. Kıymet nakli, yönetici ve misafir ulaşımı, kritik yük hareketleri ile etkinlik bazlı geçici tahsis taleplerini; güzergâh planlaması, refakat ekibi ve kayıt altına alınan teslim zinciriyle tek muhatap üzerinden yönetiyoruz.

## Hizmet Kapsamımız

- Para ve kıymetli eşya nakli (nakit, döviz, kıymetli maden ve evrak)
- Kasa–şube–merkez transferleri ve nokta besleme operasyonları
- VIP, yönetici ve misafir ulaşımı için şoförlü zırhlı araç tahsisi
- Koruma ekibi refakatinde konvoy ve güzergâh yönetimi
- Kurumsal personel taşıma ile kritik ekipman ve hassas yük nakli
- Etkinlik, proje ve kurumsal ziyaret bazlı kısa süreli araç + ekip tahsisi

## Operasyon Güvenliği

Her görev, taşınan değerin niteliği ve güzergâh risk profili çıkarılarak planlanır. Ana güzergâhın yanında alternatif güzergâh ve durma noktaları önceden belirlenir; araçlar hareket halindeyken operasyon merkezimizle kesintisiz haberleşme içinde tutulur. Teslim–tesellüm zinciri imzalı tutanak ve mühürlü taşıma kabıyla belgelenir; görev sonunda müşteriye kapanış raporu iletilir.

## Görevlendirilen Personel

Taşıma ve refakat görevlerinde çalışan personelimiz, 5188 sayılı Özel Güvenlik Hizmetlerine Dair Kanun kapsamındaki eğitimini tamamlamış ve kimliklendirilmiş kadromuzdan seçilir. Sürücülerimiz savunmacı sürüş, acil durum tahliyesi ve ilk yardım eğitimlerinden geçer; her görev öncesi ekip brifingi yapılır.

## Tahsis Modelleri

Hizmeti üç modelde veriyoruz: tek seferlik veya etkinlik bazlı **kısa süreli tahsis**, belirli bir projeye bağlı **dönemsel tahsis** ve aylık/yıllık **sözleşmeli tahsis**. Araç sınıfı, ekip büyüklüğü ve görev sıklığı; talebin risk profiline göre birlikte belirlenir.

## Anadolu Yakası ve Hizmet Bölgelerimiz

İstanbul **Anadolu Yakası merkezli** operasyon yapımız sayesinde Kadıköy, Ataşehir, Ümraniye, Üsküdar, Maltepe, Kartal, Pendik, Tuzla, Sancaktepe, Çekmeköy, Beykoz ve Sultanbeyli başta olmak üzere tüm Anadolu Yakası'ndan kalkışlı taleplere hızlı yanıt veriyoruz. İstanbul geneli ve şehirler arası görevler, güzergâh planlaması yapılarak karşılanır.

## Neden Anadolu Terra?

Taşıma hizmetini tek başına değil, koruma, elektronik güvenlik ve tesis yönetimi operasyonlarıyla aynı sözleşme altında sunabiliyoruz. Tesisinizin girişindeki güvenlik ekibiyle aracınızdaki refakat ekibi aynı operasyon merkezine bağlı çalıştığından, kapıdan kapıya kesintisiz bir güvenlik zinciri kurulur.`,
    content_en: `Anadolu Terra extends the field discipline of its private security operations — running since 2004 — to armored vehicle allocation and secure transport. Valuables movements, executive and guest travel, critical cargo transfers and short-notice event allocations are managed through a single point of contact, with route planning, escort teams and a fully documented chain of custody.

## Scope of Service

- Cash and valuables transport (currency, precious metals, documents)
- Vault–branch–headquarters transfers and point replenishment runs
- Chauffeured armored vehicles for executives, VIPs and guests
- Convoy and route management with close-protection escort
- Corporate staff transport and movement of critical or sensitive equipment
- Short-term vehicle and team allocation for events, projects and corporate visits

## Operational Security

Every assignment starts with a profile of the asset in transit and a risk assessment of the route. Primary and alternate routes, plus authorized stopping points, are defined in advance; vehicles remain in continuous contact with our operations centre while in motion. The chain of custody is documented with signed handover records and sealed containers, and a closing report is issued to the client after each run.

## Assigned Personnel

Transport and escort duties are staffed from our licensed team, trained under Turkey's Law No. 5188 on Private Security Services. Drivers complete defensive driving, emergency evacuation and first-aid training, and every assignment begins with a team briefing.

## Allocation Models

The service is offered in three models: **short-term allocation** for one-off or event-based needs, **project-based allocation** for a defined period, and **contracted allocation** on a monthly or annual basis. Vehicle class, team size and frequency are set together with the client according to the risk profile.

## Service Area

Operating from the Anatolian side of Istanbul, we respond quickly to requests originating in Kadıköy, Ataşehir, Ümraniye, Üsküdar, Maltepe, Kartal, Pendik, Tuzla and the surrounding districts, and cover city-wide and intercity assignments with advance route planning.

## Why Anadolu Terra

Transport is not delivered in isolation: it sits under the same contract as our guarding, electronic security and facility management operations. Because the officers at your gate and the escort in your vehicle report to the same operations centre, the security chain stays unbroken from door to door.`,
    content_it: `Anadolu Terra estende la disciplina operativa maturata dal 2004 nella sicurezza privata ai servizi di veicoli blindati e trasporto sicuro. Trasporto valori, spostamenti di dirigenti e ospiti, movimentazione di carichi critici e assegnazioni temporanee per eventi sono gestiti tramite un unico referente, con pianificazione dei percorsi, squadre di scorta e catena di custodia documentata.

## Ambito del Servizio

- Trasporto di contante e valori (valuta, metalli preziosi, documenti)
- Trasferimenti caveau–filiale–sede e rifornimento di punti operativi
- Veicoli blindati con autista per dirigenti, VIP e ospiti
- Gestione di convogli e percorsi con scorta di protezione ravvicinata
- Trasporto del personale aziendale e di attrezzature critiche o sensibili
- Assegnazione a breve termine di veicoli e squadre per eventi, progetti e visite aziendali

## Sicurezza Operativa

Ogni incarico parte dal profilo del bene trasportato e dall'analisi del rischio del percorso. Percorsi principali e alternativi, con i punti di sosta autorizzati, sono definiti in anticipo; i veicoli restano in contatto continuo con la nostra centrale operativa. La catena di custodia è documentata con verbali firmati e contenitori sigillati e, al termine, viene emesso un rapporto di chiusura.

## Personale Impiegato

Le attività di trasporto e scorta sono affidate a personale formato ai sensi della Legge turca n. 5188 sui Servizi di Sicurezza Privata. Gli autisti seguono corsi di guida difensiva, evacuazione d'emergenza e primo soccorso; ogni incarico inizia con un briefing di squadra.

## Modelli di Assegnazione

Il servizio è disponibile in tre modelli: **assegnazione a breve termine** per esigenze singole o legate a eventi, **assegnazione di progetto** per un periodo definito e **assegnazione a contratto** su base mensile o annuale. Classe del veicolo, dimensione della squadra e frequenza sono definite insieme al cliente in base al profilo di rischio.

## Area di Servizio

Con base operativa sul lato anatolico di Istanbul rispondiamo rapidamente alle richieste provenienti da Kadıköy, Ataşehir, Ümraniye, Üsküdar, Maltepe, Kartal, Pendik, Tuzla e dai distretti limitrofi, coprendo incarichi cittadini e interurbani con pianificazione anticipata del percorso.

## Perché Anadolu Terra

Il trasporto non è un servizio isolato: rientra nello stesso contratto delle nostre operazioni di vigilanza, sicurezza elettronica e facility management. Poiché gli operatori all'ingresso e la scorta a bordo fanno capo alla stessa centrale operativa, la catena di sicurezza resta continua da porta a porta.`,
    title_de: "Panzerfahrzeug-Bereitstellung & Sicherer Transport",
    summary_de: "Werttransport, VIP-Fahrzeugbereitstellung und Transport kritischer Güter mit Sicherheitsdisziplin.",
    content_de: `Anadolu Terra überträgt die seit 2004 in der privaten Sicherheit aufgebaute Einsatzdisziplin auf die Bereitstellung von Panzerfahrzeugen und den sicheren Transport. Werttransporte, Fahrten von Führungskräften und Gästen, Bewegungen kritischer Güter sowie kurzfristige Bereitstellungen für Veranstaltungen werden über einen einzigen Ansprechpartner gesteuert — mit Routenplanung, Begleitteams und dokumentierter Übergabekette.

## Leistungsumfang

- Bargeld- und Werttransport (Devisen, Edelmetalle, Dokumente)
- Transfers zwischen Tresor, Filiale und Zentrale sowie Bestückungsfahrten
- Gepanzerte Fahrzeuge mit Fahrer für Führungskräfte, VIPs und Gäste
- Konvoi- und Routenmanagement mit Personenschutzbegleitung
- Mitarbeitertransport sowie Transport kritischer und sensibler Ausrüstung
- Kurzfristige Fahrzeug- und Teambereitstellung für Events, Projekte und Firmenbesuche

## Einsatzsicherheit

Jeder Auftrag beginnt mit dem Profil des transportierten Guts und einer Risikoanalyse der Strecke. Haupt- und Ausweichrouten sowie zulässige Haltepunkte werden vorab festgelegt; die Fahrzeuge stehen unterwegs in ständigem Kontakt mit unserer Einsatzzentrale. Die Übergabekette wird mit unterzeichneten Protokollen und versiegelten Behältern dokumentiert, im Anschluss erhält der Kunde einen Abschlussbericht.

## Eingesetztes Personal

Transport- und Begleitaufgaben werden von Mitarbeitenden übernommen, die die Ausbildung nach dem türkischen Gesetz Nr. 5188 über private Sicherheitsdienste abgeschlossen haben. Fahrer absolvieren Trainings in defensivem Fahren, Notfallevakuierung und Erster Hilfe; vor jedem Einsatz erfolgt ein Team-Briefing.

## Bereitstellungsmodelle

Das Angebot besteht aus drei Modellen: **kurzfristige Bereitstellung** für einmalige oder veranstaltungsbezogene Bedarfe, **projektbezogene Bereitstellung** für einen definierten Zeitraum und **vertragliche Bereitstellung** auf Monats- oder Jahresbasis. Fahrzeugklasse, Teamgröße und Frequenz werden gemeinsam nach Risikoprofil festgelegt.

## Einsatzgebiet

Von der anatolischen Seite Istanbuls aus reagieren wir schnell auf Anfragen aus Kadıköy, Ataşehir, Ümraniye, Üsküdar, Maltepe, Kartal, Pendik, Tuzla und den umliegenden Bezirken; stadtweite und überregionale Einsätze werden mit vorheriger Routenplanung abgedeckt.

## Warum Anadolu Terra

Der Transport steht nicht für sich allein, sondern unter demselben Vertrag wie unsere Bewachungs-, Elektronikschutz- und Facility-Management-Leistungen. Da das Personal an Ihrem Eingang und die Begleitung in Ihrem Fahrzeug derselben Einsatzzentrale unterstehen, bleibt die Sicherheitskette von Tür zu Tür geschlossen.`,
    title_es: "Asignación de Vehículos Blindados y Transporte Seguro",
    summary_es: "Transporte de valores, asignación de vehículos VIP y movimiento de carga crítica con disciplina de seguridad.",
    content_es: `Anadolu Terra traslada la disciplina operativa desarrollada en seguridad privada desde 2004 a la asignación de vehículos blindados y el transporte seguro. Traslados de valores, desplazamientos de directivos e invitados, movimientos de carga crítica y asignaciones puntuales para eventos se gestionan con un único interlocutor, con planificación de rutas, equipos de escolta y cadena de custodia documentada.

## Alcance del Servicio

- Transporte de efectivo y valores (divisas, metales preciosos, documentos)
- Transferencias caja fuerte–sucursal–sede y rutas de reposición
- Vehículos blindados con conductor para directivos, VIP e invitados
- Gestión de convoyes y rutas con escolta de protección personal
- Transporte de personal corporativo y de equipos críticos o sensibles
- Asignación a corto plazo de vehículos y equipos para eventos, proyectos y visitas

## Seguridad Operativa

Cada servicio parte del perfil del bien transportado y del análisis de riesgo de la ruta. Se definen de antemano rutas principales y alternativas, así como los puntos de parada autorizados; los vehículos mantienen contacto continuo con nuestro centro de operaciones. La cadena de custodia se documenta con actas firmadas y contenedores precintados, y al finalizar se emite un informe de cierre.

## Personal Asignado

Las tareas de transporte y escolta se cubren con personal formado conforme a la Ley turca n.º 5188 de Servicios de Seguridad Privada. Los conductores reciben formación en conducción defensiva, evacuación de emergencia y primeros auxilios; cada servicio comienza con un briefing del equipo.

## Modelos de Asignación

El servicio se ofrece en tres modelos: **asignación a corto plazo** para necesidades puntuales o eventos, **asignación por proyecto** durante un periodo definido y **asignación contratada** con base mensual o anual. La clase de vehículo, el tamaño del equipo y la frecuencia se definen junto al cliente según el perfil de riesgo.

## Área de Servicio

Con base operativa en el lado anatolio de Estambul, respondemos con rapidez a solicitudes procedentes de Kadıköy, Ataşehir, Ümraniye, Üsküdar, Maltepe, Kartal, Pendik, Tuzla y distritos cercanos, y cubrimos servicios en toda la ciudad e interurbanos con planificación previa de ruta.

## Por qué Anadolu Terra

El transporte no se presta de forma aislada: se integra en el mismo contrato que nuestras operaciones de vigilancia, seguridad electrónica y gestión de instalaciones. Como el personal de su acceso y la escolta de su vehículo dependen del mismo centro de operaciones, la cadena de seguridad se mantiene continua de puerta a puerta.`,
    title_ru: "Бронеавтомобили и безопасная перевозка",
    summary_ru: "Перевозка ценностей, предоставление VIP-автомобилей и транспортировка критических грузов по стандартам охраны.",
    content_ru: `Anadolu Terra переносит операционную дисциплину, накопленную в частной охране с 2004 года, на предоставление бронеавтомобилей и безопасную перевозку. Инкассация ценностей, поездки руководителей и гостей, перемещение критических грузов и краткосрочное выделение транспорта под мероприятия ведутся через единого куратора — с планированием маршрута, группой сопровождения и документированной цепочкой передачи.

## Объём услуг

- Перевозка наличных и ценностей (валюта, драгоценные металлы, документы)
- Трансферы «хранилище — отделение — головной офис» и пополнение точек
- Бронеавтомобили с водителем для руководителей, VIP-персон и гостей
- Управление колонной и маршрутом с группой личной охраны
- Перевозка сотрудников компании и критического или чувствительного оборудования
- Краткосрочное выделение транспорта и экипажа под мероприятия, проекты и визиты

## Операционная безопасность

Каждое задание начинается с профиля перевозимого актива и оценки риска маршрута. Основной и резервный маршруты, а также разрешённые точки остановки определяются заранее; в пути автомобили находятся на постоянной связи с нашим оперативным центром. Цепочка передачи фиксируется подписанными актами и опломбированными контейнерами, по завершении заказчику направляется итоговый отчёт.

## Задействованный персонал

Перевозку и сопровождение выполняют сотрудники, прошедшие подготовку в соответствии с турецким Законом № 5188 о частных охранных услугах. Водители проходят обучение защитному вождению, аварийной эвакуации и первой помощи; перед каждым выездом проводится инструктаж экипажа.

## Модели предоставления

Услуга доступна в трёх моделях: **краткосрочное выделение** под разовые задачи и мероприятия, **проектное выделение** на определённый период и **контрактное выделение** на месяц или год. Класс автомобиля, численность экипажа и периодичность определяются совместно с заказчиком по профилю риска.

## Зона обслуживания

Опираясь на операционную базу на азиатской стороне Стамбула, мы быстро реагируем на заявки из районов Кадыкёй, Аташехир, Умрание, Ускюдар, Мальтепе, Картал, Пендик, Тузла и соседних, а также выполняем задания по всему городу и междугородние рейсы с предварительным планированием маршрута.

## Почему Anadolu Terra

Перевозка не существует отдельно — она входит в тот же договор, что и охрана объектов, электронные системы безопасности и управление недвижимостью. Поскольку сотрудники на входе и сопровождение в автомобиле подчиняются одному оперативному центру, цепочка безопасности остаётся непрерывной «от двери до двери».`,
    title_fr: "Mise à Disposition de Véhicules Blindés & Transport Sécurisé",
    summary_fr: "Transport de valeurs, mise à disposition de véhicules VIP et acheminement de charges critiques sous discipline de sécurité.",
    content_fr: `Anadolu Terra applique à la mise à disposition de véhicules blindés et au transport sécurisé la discipline opérationnelle acquise dans la sécurité privée depuis 2004. Transports de valeurs, déplacements de dirigeants et d'invités, mouvements de charges critiques et mises à disposition ponctuelles pour événements sont pilotés par un interlocuteur unique, avec planification d'itinéraire, équipes d'escorte et chaîne de traçabilité documentée.

## Périmètre du Service

- Transport d'espèces et de valeurs (devises, métaux précieux, documents)
- Transferts coffre–agence–siège et tournées d'approvisionnement
- Véhicules blindés avec chauffeur pour dirigeants, VIP et invités
- Gestion de convois et d'itinéraires avec escorte de protection rapprochée
- Transport du personnel et d'équipements critiques ou sensibles
- Mise à disposition à court terme de véhicules et d'équipes pour événements, projets et visites

## Sécurité Opérationnelle

Chaque mission débute par le profil du bien transporté et l'analyse de risque du trajet. Itinéraires principal et alternatif ainsi que points d'arrêt autorisés sont définis à l'avance ; les véhicules restent en liaison permanente avec notre centre d'opérations. La chaîne de traçabilité est documentée par des procès-verbaux signés et des contenants scellés, et un rapport de clôture est remis au client.

## Personnel Affecté

Les missions de transport et d'escorte sont assurées par des personnels formés au titre de la loi turque n° 5188 sur les services de sécurité privée. Les chauffeurs suivent des formations de conduite défensive, d'évacuation d'urgence et de premiers secours ; chaque mission commence par un briefing d'équipe.

## Modèles de Mise à Disposition

Le service existe en trois modèles : **mise à disposition ponctuelle** pour un besoin unique ou événementiel, **mise à disposition projet** sur une période définie et **mise à disposition contractuelle** au mois ou à l'année. Classe de véhicule, taille d'équipe et fréquence sont arrêtées avec le client selon le profil de risque.

## Zone d'Intervention

Depuis notre base opérationnelle sur la rive anatolienne d'Istanbul, nous répondons rapidement aux demandes issues de Kadıköy, Ataşehir, Ümraniye, Üsküdar, Maltepe, Kartal, Pendik, Tuzla et des arrondissements voisins, et couvrons les missions à l'échelle de la ville et interurbaines avec planification préalable.

## Pourquoi Anadolu Terra

Le transport n'est pas isolé : il relève du même contrat que nos opérations de gardiennage, de sécurité électronique et de facility management. Les agents à votre entrée et l'escorte dans votre véhicule dépendant du même centre d'opérations, la chaîne de sécurité reste continue de porte à porte.`,
    image_url: null,
  },
  {
    id: "f3",
    slug: "genel-temizlik",
    icon: "Sparkles",
    title_tr: "Genel Temizlik",
    title_en: "General Cleaning",
    title_it: "Pulizie Generali",
    summary_tr: "İnsan sağlığını ön planda tutarak kaliteli ve yaşanabilir bir ortam sağlıyoruz.",
    summary_en: "Healthy, comfortable environments through quality cleaning.",
    summary_it: "Ambienti sani e confortevoli grazie a pulizie di qualità che mettono la salute al primo posto.",
    content_tr: `Ofis, plaza, hastane, okul, fabrika ve ortak kullanım alanlarında hijyen odaklı profesyonel temizlik hizmetleri sunuyoruz. Sertifikalı kimyasallar, endüstriyel ekipmanlar ve denetlenebilir operasyon süreçleriyle her tesisin standartlarına uygun temizlik planı oluşturuyoruz.

## Hizmet Kapsamımız

- Günlük ofis ve ortak alan temizliği
- Genel ve detay (derin) temizlik
- Cam ve dış cephe temizliği (iple erişim/yüksekte çalışma)
- İnşaat ve tadilat sonrası temizlik
- Halı, koltuk ve yüzey yıkama
- Hastane ve sağlık tesisleri için hijyenik temizlik
- Endüstriyel ve üretim alanı temizliği

## Kullanılan Ürün ve Ekipmanlar

Sağlık Bakanlığı onaylı, biyosidal sertifikalı temizlik ürünleri kullanıyoruz. Talep edilen alanlarda çevre dostu (eko-etiketli), düşük kokulu ve alerjen içermeyen ürünleri tercih ediyoruz. Endüstriyel zemin makineleri, HEPA filtreli süpürgeler ve mikrofiber sistemler standart ekipman setimizdir.

## Personel ve Eğitim

Tüm temizlik personeli SGK kayıtlı, hijyen sertifikalı ve düzenli sağlık kontrolünden geçmektedir. Yeni katılan her personel oryantasyon ve iş güvenliği eğitiminden sonra sahada görevlendirilir.

## Denetim ve Raporlama

Günlük, haftalık ve aylık görev listeleri, denetim formları ve memnuniyet anketleriyle hizmet kalitesini sürekli ölçüyor; sonuçları aylık raporla paylaşıyoruz.`,
    content_en: `We deliver hygiene-focused professional cleaning for offices, plazas, hospitals, schools, factories and shared areas. Certified chemicals, industrial equipment and auditable processes shape a cleaning plan that matches each facility's standards.

## Scope of Service

- Daily office and common-area cleaning
- General and detail (deep) cleaning
- Window and façade cleaning (rope access / work-at-height)
- Post-construction cleaning
- Carpet, sofa and surface washing
- Hygienic cleaning for hospitals and healthcare
- Industrial and production-area cleaning

## Products and Equipment

We use Ministry of Health-approved, biocide-certified products. Eco-labeled, low-odor and allergen-free products are available on request. Industrial floor machines, HEPA-filter vacuums and microfiber systems are part of our standard kit.

## Personnel and Training

All cleaning staff are SGK-registered, hygiene-certified and pass regular health checks. Every new hire completes orientation and OHS training before being deployed.

## Audit and Reporting

Daily, weekly and monthly task lists, inspection forms and satisfaction surveys continuously measure service quality, with monthly reports.`,
    content_it: `Eroghiamo pulizie professionali orientate all'igiene per uffici, plazas, ospedali, scuole, fabbriche e aree comuni. Prodotti chimici certificati, attrezzature industriali e processi tracciabili definiscono un piano di pulizia adatto agli standard di ogni struttura.

## Ambito del Servizio

- Pulizia quotidiana di uffici e aree comuni
- Pulizia generale e di dettaglio (deep cleaning)
- Pulizia di vetri e facciate (accesso su corda / lavori in quota)
- Pulizia post-cantiere
- Lavaggio di tappeti, divani e superfici
- Pulizia igienica per ospedali e strutture sanitarie
- Pulizia industriale e di aree produttive

## Prodotti e Attrezzature

Utilizziamo prodotti approvati dal Ministero della Salute e certificati come biocidi. Su richiesta sono disponibili prodotti ecolabel, a basso odore e privi di allergeni. Macchine lavapavimenti industriali, aspirapolveri con filtro HEPA e sistemi in microfibra fanno parte della nostra dotazione standard.

## Personale e Formazione

Tutto il personale è regolarmente assunto, certificato in materia di igiene e sottoposto a controlli sanitari periodici. Ogni nuovo assunto completa orientamento e formazione sulla sicurezza prima di essere assegnato al sito.

## Audit e Reportistica

Liste di attività giornaliere, settimanali e mensili, moduli di ispezione e sondaggi di soddisfazione misurano costantemente la qualità del servizio, con report mensili.`,
    title_de: "Allgemeine Reinigungsdienstleistungen",
    summary_de: "Gesunde, komfortable Umgebungen durch professionelle Reinigung mit zertifizierten Produkten.",
    content_de: `Wir erbringen hygienefokussierte professionelle Reinigungsdienstleistungen für Büros, Büroplexe, Krankenhäuser, Schulen, Fabriken und Gemeinschaftsbereiche in Istanbul und der gesamten Türkei. Zertifizierte Chemikalien, Industrieausrüstung und nachvollziehbare Prozesse bilden einen auf die Standards jeder Einrichtung abgestimmten Reinigungsplan.

## Leistungsumfang

- Tägliche Büro- und Gemeinschaftsbereichsreinigung
- Allgemeine und Detail-(Tiefen-)Reinigung
- Fenster- und Fassadenreinigung (Seilzugangstechnik / Arbeiten in der Höhe)
- Baureinigung nach Abschluss von Bau- und Renovierungsarbeiten
- Teppich-, Polster- und Oberflächenwäsche
- Hygienische Reinigung in Krankenhäusern und Gesundheitseinrichtungen
- Industrie- und Produktionsbereichsreinigung

## Produkte und Ausrüstung

Wir verwenden vom Gesundheitsministerium zugelassene, biozid-zertifizierte Produkte. Auf Wunsch stehen ecolabel-zertifizierte, geruchsarme und allergenfreie Produkte zur Verfügung. Industrielle Bodenreinigungsmaschinen, HEPA-Filterstaubsauger und Mikrofasersysteme gehören zu unserer Standardausstattung.

## Personal und Schulung

Alle Reinigungsmitarbeiter sind sozialversicherungspflichtig beschäftigt, hygienezertifiziert und unterlaufen regelmäßige Gesundheitschecks. Jeder neue Mitarbeiter absolviert eine Einführung und Arbeitssicherheitsschulung, bevor er eingesetzt wird.

## Prüfung und Berichterstattung

Tägliche, wöchentliche und monatliche Aufgabenlisten, Inspektionsformulare und Zufriedenheitsumfragen messen kontinuierlich die Servicequalität, ergänzt durch monatliche Berichte.`,
    title_es: "Servicios de Limpieza General",
    summary_es: "Entornos saludables y confortables mediante una limpieza profesional de calidad.",
    content_es: `Prestamos servicios de limpieza profesional centrados en la higiene para oficinas, plazas, hospitales, escuelas, fábricas y zonas comunes en Estambul y toda Turquía. Productos químicos certificados, equipos industriales y procesos auditables definen un plan de limpieza adaptado a los estándares de cada instalación.

## Alcance del Servicio

- Limpieza diaria de oficinas y zonas comunes
- Limpieza general y de detalle (limpieza profunda)
- Limpieza de cristales y fachadas (acceso con cuerda / trabajo en altura)
- Limpieza post-construcción y post-reforma
- Lavado de alfombras, tapicería y superficies
- Limpieza higiénica para hospitales y centros sanitarios
- Limpieza industrial y de áreas de producción

## Productos y Equipos

Utilizamos productos aprobados por el Ministerio de Salud y con certificación biocida. Disponemos de productos con ecoetiqueta, de bajo olor y sin alérgenos bajo petición. Máquinas industriales de limpieza de suelos, aspiradoras con filtro HEPA y sistemas de microfibra forman parte de nuestro equipo estándar.

## Personal y Formación

Todo el personal de limpieza está dado de alta en la Seguridad Social, posee certificación en higiene y pasa controles de salud periódicos. Cada nuevo empleado completa orientación y formación en prevención de riesgos laborales antes de ser asignado.

## Auditoría e Informes

Listas de tareas diarias, semanales y mensuales, formularios de inspección y encuestas de satisfacción miden continuamente la calidad del servicio, con informes mensuales.`,
    title_ru: "Услуги по уборке помещений",
    summary_ru: "Здоровая и комфортная среда благодаря профессиональной уборке с сертифицированными средствами.",
    content_ru: `Мы оказываем гигиеническую профессиональную уборку для офисов, бизнес-центров, больниц, школ, заводов и мест общего пользования в Стамбуле и по всей Турции. Сертифицированные химические средства, промышленное оборудование и прозрачные процессы формируют план уборки, соответствующий стандартам каждого объекта.

## Спектр услуг

- Ежедневная уборка офисов и мест общего пользования
- Генеральная и детальная (глубокая) уборка
- Мойка окон и фасадов (промышленный альпинизм / работы на высоте)
- Уборка после строительства и ремонта
- Химчистка ковров, мягкой мебели и поверхностей
- Гигиеническая уборка в больницах и медицинских учреждениях
- Уборка промышленных и производственных помещений

## Средства и оборудование

Мы используем средства, одобренные Министерством здравоохранения и сертифицированные как биоциды. По запросу доступны экологически сертифицированные, малоароматные и гипоаллергенные средства. В стандартный набор входят промышленные поломоечные машины, пылесосы с HEPA-фильтром и микрофибровые системы.

## Персонал и обучение

Весь персонал официально трудоустроен, имеет сертификат по гигиене и проходит регулярные медицинские осмотры. Каждый новый сотрудник проходит вводный инструктаж и обучение по охране труда перед выходом на объект.

## Аудит и отчётность

Ежедневные, еженедельные и ежемесячные рабочие списки, акты проверки и анкеты удовлетворённости постоянно измеряют качество сервиса, дополняемые ежемесячными отчётами.`,
    title_fr: "Services de Nettoyage Général",
    summary_fr: "Des environnements sains et confortables grâce à un nettoyage professionnel de qualité.",
    content_fr: `Nous proposons des services de nettoyage professionnel axés sur l'hygiène pour les bureaux, les plazas, les hôpitaux, les écoles, les usines et les espaces communs à Istanbul et dans toute la Turquie. Des produits chimiques certifiés, un équipement industriel et des processus auditables définissent un plan de nettoyage adapté aux normes de chaque établissement.

## Périmètre des Services

- Nettoyage quotidien des bureaux et des espaces communs
- Nettoyage général et de détail (nettoyage en profondeur)
- Nettoyage des vitres et des façades (accès sur corde / travaux en hauteur)
- Nettoyage post-construction
- Lavage des tapis, canapés et surfaces
- Nettoyage hygiénique pour les hôpitaux et les établissements de santé
- Nettoyage industriel et des zones de production

## Produits et Équipements

Nous utilisons des produits approuvés par le ministère de la Santé et certifiés biocides. Des produits écolabellisés, à faible odeur et sans allergènes sont disponibles sur demande. Des machines industrielles de nettoyage des sols, des aspirateurs à filtre HEPA et des systèmes en microfibre font partie de notre équipement standard.

## Personnel et Formation

Tout le personnel de nettoyage est déclaré, certifié en hygiène et soumis à des contrôles de santé réguliers. Chaque nouvel employé suit une formation d'orientation et de sécurité au travail avant d'être affecté.

## Audit et Reporting

Des listes de tâches quotidiennes, hebdomadaires et mensuelles, des formulaires d'inspection et des enquêtes de satisfaction mesurent en permanence la qualité du service, avec des rapports mensuels.`,
    image_url: null,
  },
  {
    id: "f4",
    slug: "tesis-yonetimi",
    icon: "Building2",
    title_tr: "Tesis Yönetimi",
    title_en: "Facility Management",
    title_it: "Gestione Immobiliare",
    summary_tr: "Apartman, site ve ticari tesisler için profesyonel tesis yönetimi çözümleri sunuyoruz.",
    summary_en: "Full-service management for residences and commercial complexes.",
    summary_it: "Soluzioni complete di gestione per condomini, residenze e complessi commerciali.",
    content_tr: `Apartman, site, plaza, AVM ve ticari tesislerde entegre tesis yönetimi (Integrated Facility Management) hizmetleri sunuyoruz. Teknik bakım, güvenlik, temizlik, ilaçlama, tedarikçi yönetimi, enerji takibi ve finansal raporlama gibi tüm operasyonel süreçleri tek bir muhatap üzerinden yönetiyoruz.

## Hizmet Kapsamımız

- Teknik bakım ve onarım (mekanik, elektrik, sıhhi tesisat, jeneratör, asansör koordinasyonu)
- Bütçe hazırlama, gider takibi ve aylık finansal raporlama
- Aidat ve tahsilat süreç yönetimi
- Tedarikçi seçimi, sözleşme yönetimi ve fatura kontrolü
- Enerji ve su tüketimi izleme, tasarruf önerileri
- Kanun ve mevzuat uyumu (KMK, iş güvenliği, KVKK)
- Sakin/kullanıcı iletişimi ve şikâyet yönetimi

## Yönetim Yaklaşımımız

Müşteri odaklı, ölçülebilir ve şeffaf bir yönetim modeli benimsiyoruz. Her tesis için KPI seti (memnuniyet, çağrı çözüm süresi, planlı bakım uyumu, enerji tasarrufu) tanımlanır ve yönetim kuruluna aylık raporlanır.

## Dijital Altyapı

Arıza takip sistemi, ziyaretçi yönetimi, aidat tahsilat portalı ve mobil sakin uygulamasıyla operasyonu uçtan uca dijitalleştiriyoruz. Tüm veri tek bir panoda görüntülenebilir ve yönetim kurulu istediği zaman raporlara erişebilir.

## Devir Süreci

Mevcut yönetimden devralma için 30-60 günlük yapılandırılmış geçiş planı uygularız: envanter tespiti, personel oryantasyonu, sözleşme analizi, süreç dijitalleştirmesi ve sakin iletişimi.`,
    content_en: `We provide Integrated Facility Management (IFM) for residences, complexes, plazas, malls and commercial facilities. Technical maintenance, security, cleaning, pest control, vendor management, energy tracking and financial reporting — all delivered through a single point of contact.

## Scope of Service

- Technical maintenance (mechanical, electrical, plumbing, generator, lift coordination)
- Budgeting, expense tracking and monthly financial reporting
- Fee billing and collection management
- Vendor selection, contract management and invoice control
- Energy and water consumption monitoring with savings recommendations
- Legal and regulatory compliance (KMK, OHS, KVKK/GDPR)
- Resident/user communication and complaint management

## Management Approach

Customer-focused, measurable and transparent. Each facility has a KPI set (satisfaction, ticket resolution time, planned-maintenance compliance, energy savings) reported monthly to the board.

## Digital Infrastructure

Ticketing, visitor management, fee-collection portal and a mobile resident app digitize operations end-to-end. All data lives in a single dashboard accessible to the board at any time.

## Handover Process

Structured 30-60 day handover: inventory audit, staff onboarding, contract review, process digitization and resident communication.`,
    content_it: `Offriamo Integrated Facility Management (IFM) per residenze, complessi, plazas, centri commerciali e strutture commerciali. Manutenzione tecnica, sicurezza, pulizie, disinfestazione, gestione fornitori, monitoraggio energetico e reportistica finanziaria — tutto attraverso un unico interlocutore.

## Ambito del Servizio

- Manutenzione tecnica (meccanica, elettrica, idraulica, gruppo elettrogeno, coordinamento ascensori)
- Predisposizione del budget, controllo delle spese e reportistica finanziaria mensile
- Gestione di emissione quote e incassi
- Selezione fornitori, gestione contratti e controllo fatture
- Monitoraggio dei consumi di energia e acqua con suggerimenti di risparmio
- Conformità normativa (KMK, sicurezza sul lavoro, KVKK/GDPR)
- Comunicazione con residenti/utenti e gestione dei reclami

## Approccio Gestionale

Orientato al cliente, misurabile e trasparente. Ogni struttura ha un set di KPI (soddisfazione, tempo di risoluzione ticket, rispetto della manutenzione programmata, risparmio energetico) riportato mensilmente al consiglio.

## Infrastruttura Digitale

Ticketing, gestione visitatori, portale di incassi e app mobile per i residenti digitalizzano le operazioni end-to-end. Tutti i dati risiedono in un'unica dashboard accessibile al consiglio in qualsiasi momento.

## Processo di Subentro

Subentro strutturato in 30-60 giorni: audit inventario, onboarding del personale, revisione contratti, digitalizzazione dei processi e comunicazione con i residenti.`,
    title_de: "Facility Management",
    summary_de: "Vollständiges Facility Management für Wohnanlagen und gewerbliche Komplexe.",
    content_de: `Wir bieten Integriertes Facility Management (IFM) für Wohnanlagen, Komplexe, Büroplexe, Einkaufszentren und Gewerbeimmobilien in Istanbul und der gesamten Türkei. Technische Wartung, Sicherheit, Reinigung, Schädlingsbekämpfung, Lieferantenmanagement, Energieüberwachung und Finanzberichterstattung — alles über einen einzigen Ansprechpartner.

## Leistungsumfang

- Technische Wartung und Instandhaltung (Mechanik, Elektrik, Sanitär, Generator, Aufzugskoordination)
- Budgeterstellung, Ausgabenverfolgung und monatliche Finanzberichterstattung
- Hausgeldabrechnung und Inkassomanagement
- Lieferantenauswahl, Vertragsmanagement und Rechnungskontrolle
- Energie- und Wasserverbrauchsüberwachung mit Einsparempfehlungen
- Rechts- und Compliance-Konformität (KMK, Arbeitssicherheit, KVKK/DSGVO)
- Bewohner-/Nutzerkommunikation und Beschwerdemanagement

## Managementansatz

Kundenorientiert, messbar und transparent. Jede Einrichtung erhält einen KPI-Satz (Zufriedenheit, Ticketlösungszeit, Einhaltung der geplanten Wartung, Energieeinsparungen), der monatlich an den Vorstand berichtet wird.

## Digitale Infrastruktur

Ticketing, Besuchermanagement, Hausgeldportal und eine mobile Bewohner-App digitalisieren den Betrieb von Anfang bis Ende. Alle Daten befinden sich in einem einzigen Dashboard, das dem Vorstand jederzeit zugänglich ist.

## Übergabeprozess

Strukturierte Übergabe in 30-60 Tagen: Inventarprüfung, Mitarbeitereinführung, Vertragsüberprüfung, Prozessdigitalisierung und Bewohnerkommunikation.`,
    title_es: "Gestión de Instalaciones",
    summary_es: "Gestión integral de instalaciones para residencias y complejos comerciales.",
    content_es: `Ofrecemos Gestión Integral de Instalaciones (IFM) para residencias, complejos, plazas, centros comerciales e instalaciones comerciales en Estambul y toda Turquía. Mantenimiento técnico, seguridad, limpieza, control de plagas, gestión de proveedores, seguimiento energético e informes financieros — todo a través de un único interlocutor.

## Alcance del Servicio

- Mantenimiento técnico (mecánica, electricidad, fontanería, generador, coordinación de ascensores)
- Elaboración de presupuestos, seguimiento de gastos e informes financieros mensuales
- Gestión de cuotas y cobros
- Selección de proveedores, gestión de contratos y control de facturas
- Monitorización del consumo de energía y agua con recomendaciones de ahorro
- Cumplimiento legal y normativo (KMK, seguridad laboral, KVKK/GDPR)
- Comunicación con residentes/usuarios y gestión de reclamaciones

## Enfoque de Gestión

Orientado al cliente, medible y transparente. Cada instalación tiene un conjunto de KPIs (satisfacción, tiempo de resolución de incidencias, cumplimiento del mantenimiento planificado, ahorro energético) que se informa mensualmente al consejo.

## Infraestructura Digital

Sistema de tickets, gestión de visitas, portal de cobro de cuotas y app móvil para residentes digitalizan las operaciones de extremo a extremo. Todos los datos residen en un único panel accesible al consejo en cualquier momento.

## Proceso de Traspaso

Traspaso estructurado en 30-60 días: auditoría de inventario, incorporación del personal, revisión de contratos, digitalización de procesos y comunicación con residentes.`,
    title_ru: "Управление объектами",
    summary_ru: "Комплексное управление жилыми и коммерческими объектами.",
    content_ru: `Мы предоставляем услуги комплексного управления объектами (IFM) для жилых комплексов, бизнес-центров, торговых центров и коммерческих объектов в Стамбуле и по всей Турции. Техническое обслуживание, охрана, уборка, дезинсекция, управление подрядчиками, мониторинг энергопотребления и финансовая отчётность — всё через единый контакт.

## Спектр услуг

- Техническое обслуживание и ремонт (механика, электрика, сантехника, генератор, координация лифтов)
- Составление бюджета, отслеживание расходов и ежемесячная финансовая отчётность
- Управление выставлением счетов и сбором платежей
- Отбор подрядчиков, управление договорами и контроль счетов
- Мониторинг потребления энергии и воды с рекомендациями по экономии
- Соответствие законодательству и нормативным требованиям (KMK, охрана труда, KVKK/GDPR)
- Коммуникация с жильцами/пользователями и управление жалобами

## Подход к управлению

Ориентированный на клиента, измеримый и прозрачный. Для каждого объекта определяется набор KPI (удовлетворённость, время закрытия заявки, соблюдение плановых работ, экономия энергии), о которых ежемесячно отчитываются перед советом.

## Цифровая инфраструктура

Система заявок, управление посетителями, портал сбора платежей и мобильное приложение для жильцов полностью оцифровывают операции. Все данные находятся на едином дашборде, доступном совету в любое время.

## Процесс передачи управления

Структурированная передача за 30-60 дней: инвентаризация, введение персонала в должность, анализ договоров, оцифровка процессов и коммуникация с жильцами.`,
    title_fr: "Gestion des Installations",
    summary_fr: "Gestion complète des installations pour résidences et complexes commerciaux.",
    content_fr: `Nous proposons la Gestion Intégrée des Installations (IFM) pour les résidences, les complexes, les plazas, les centres commerciaux et les établissements commerciaux à Istanbul et dans toute la Turquie. Maintenance technique, sécurité, nettoyage, dératisation, gestion des fournisseurs, suivi énergétique et reporting financier — le tout via un interlocuteur unique.

## Périmètre des Services

- Maintenance technique (mécanique, électricité, plomberie, groupe électrogène, coordination des ascenseurs)
- Établissement du budget, suivi des dépenses et reporting financier mensuel
- Gestion des charges et des encaissements
- Sélection des fournisseurs, gestion des contrats et contrôle des factures
- Suivi de la consommation d'énergie et d'eau avec recommandations d'économies
- Conformité légale et réglementaire (KMK, sécurité au travail, KVKK/RGPD)
- Communication avec les résidents/utilisateurs et gestion des réclamations

## Approche de Gestion

Orientée client, mesurable et transparente. Chaque installation dispose d'un ensemble de KPI (satisfaction, délai de résolution des tickets, conformité à la maintenance planifiée, économies d'énergie) communiqué mensuellement au conseil.

## Infrastructure Numérique

Ticketing, gestion des visiteurs, portail de collecte des charges et application mobile pour les résidents numérisent les opérations de bout en bout. Toutes les données résident dans un tableau de bord unique accessible au conseil à tout moment.

## Processus de Reprise

Reprise structurée en 30-60 jours : audit d'inventaire, intégration du personnel, révision des contrats, numérisation des processus et communication avec les résidents.`,
    image_url: null,
  },
  {
    id: "f5",
    slug: "ilaclama",
    icon: "Bug",
    title_tr: "İlaçlama",
    title_en: "Pest Control",
    title_it: "Disinfestazione",
    summary_tr: "Sağlık Bakanlığı ruhsatlı, garantili ilaçlama hizmetleriyle haşere kontrolü ve dezenfeksiyon çözümleri.",
    summary_en: "Ministry of Health-licensed pest control and disinfection services.",
    summary_it: "Servizi di disinfestazione e disinfezione garantiti, autorizzati dal Ministero della Salute.",
    content_tr: `Haşere kontrolü, dezenfeksiyon ve biyosidal uygulamalarımız Sağlık Bakanlığı tarafından ruhsatlı ürünlerle ve sertifikalı uygulayıcılar tarafından gerçekleştirilir. Entegre Haşere Yönetimi (IPM) yaklaşımıyla, sadece ilaçlama değil, kalıcı çözüm odaklı bir program sunuyoruz.

## Hizmet Kapsamımız

- Hamamböceği, karınca, sinek, sivrisinek mücadelesi
- Fare ve diğer kemirgen kontrolü (kapalı istasyon takibi)
- Kene, güve ve depo zararlıları
- Yatak böceği (tahta kurusu) uygulamaları
- Genel dezenfeksiyon ve virüs/bakteri kontrolü
- Bahçe ve dış mekan ULV uygulamaları
- HACCP uyumlu gıda işletmesi IPM programları

## Uygulama Süreci

1. **Keşif ve risk analizi** — Tesis incelenir, haşere türü ve yoğunluk belirlenir.
2. **Plan ve teklif** — Uygulama yöntemi, ürün, sıklık ve garanti süresi netleştirilir.
3. **Uygulama** — Sertifikalı uygulayıcılar tarafından sahada yapılır.
4. **Takip ve raporlama** — İzleme istasyonları ve periyodik kontrollerle etkinlik takip edilir.

## Güvenlik ve Sertifikasyon

Tüm ürünlerin Sağlık Bakanlığı biyosidal ruhsatı, MSDS (Malzeme Güvenlik Bilgi Formu) ve uygulama sonrası servis raporu müşteriye sunulur. Uygulama sonrası genellikle 2-4 saat havalandırma süresi yeterlidir.

## Gıda İşletmeleri için IPM

Restoran, mutfak, market ve gıda üretim alanları için HACCP uyumlu, belgelendirme denetimlerinde kabul gören IPM programları, izleme istasyonları, trend grafikleri ve aylık raporlama sağlıyoruz.`,
    content_en: `Our pest control, disinfection and biocidal services use Ministry of Health-licensed products and are performed by certified applicators. Through an Integrated Pest Management (IPM) approach we deliver lasting results, not just one-off spraying.

## Scope of Service

- Cockroaches, ants, flies, mosquitoes
- Rats and other rodents (sealed-station monitoring)
- Ticks, moths, stored-product pests
- Bed-bug treatments
- General disinfection and virus/bacteria control
- Outdoor ULV applications
- HACCP-compliant IPM programs for food businesses

## Process

1. **Survey and risk analysis** — Site inspection, pest type and density assessment.
2. **Plan and proposal** — Method, product, frequency and warranty.
3. **Application** — On site, by certified applicators.
4. **Monitoring and reporting** — Monitoring stations and periodic checks track effectiveness.

## Safety and Certification

For every product we share the Ministry of Health biocide license, MSDS and service report. A 2-4 hour ventilation window after application is typically sufficient.

## IPM for Food Businesses

HACCP-compliant IPM programs accepted in certification audits — for restaurants, kitchens, retail and food production — with monitoring stations, trend charts and monthly reporting.`,
    content_it: `I nostri servizi di disinfestazione, disinfezione e applicazioni biocide utilizzano prodotti autorizzati dal Ministero della Salute e sono eseguiti da operatori certificati. Con un approccio di Integrated Pest Management (IPM) offriamo risultati duraturi, non semplici trattamenti spot.

## Ambito del Servizio

- Scarafaggi, formiche, mosche, zanzare
- Ratti e altri roditori (monitoraggio con stazioni sigillate)
- Zecche, tarme, infestanti dei prodotti stoccati
- Trattamenti contro le cimici dei letti
- Disinfezione generale e controllo di virus/batteri
- Trattamenti ULV in esterno
- Programmi IPM conformi HACCP per attività alimentari

## Processo

1. **Sopralluogo e analisi del rischio** — Ispezione del sito, identificazione della specie e della densità.
2. **Piano e proposta** — Metodo, prodotto, frequenza e garanzia.
3. **Applicazione** — In loco, da operatori certificati.
4. **Monitoraggio e reportistica** — Stazioni di monitoraggio e controlli periodici verificano l'efficacia.

## Sicurezza e Certificazioni

Per ogni prodotto forniamo l'autorizzazione biocida del Ministero della Salute, la SDS (Scheda Dati di Sicurezza) e il rapporto di servizio. In genere è sufficiente un periodo di aerazione di 2-4 ore dopo l'applicazione.

## IPM per Attività Alimentari

Programmi IPM conformi HACCP, accettati in audit di certificazione — per ristoranti, cucine, retail e produzione alimentare — con stazioni di monitoraggio, grafici di trend e reportistica mensile.`,
    title_de: "Schädlingsbekämpfung und Desinfektion",
    summary_de: "Vom Gesundheitsministerium zugelassene Schädlingsbekämpfung mit Ergebnisgarantie.",
    content_de: `Unsere Schädlingsbekämpfungs-, Desinfektions- und Bioziddienstleistungen verwenden vom türkischen Gesundheitsministerium zugelassene Produkte und werden von zertifizierten Anwendern durchgeführt. Mit einem Integrierten Schädlingsmanagement-Ansatz (IPM) erzielen wir nachhaltige Ergebnisse in Istanbul und der gesamten Türkei.

## Leistungsumfang

- Kakerlaken, Ameisen, Fliegen, Mücken
- Ratten und andere Nagetiere (versiegelte Überwachungsstationen)
- Zecken, Motten und Vorratsschädlinge
- Bettwanzenbehandlung
- Allgemeine Desinfektion und Virus-/Bakterienkontrolle
- ULV-Außenanwendungen
- HACCP-konforme IPM-Programme für Lebensmittelbetriebe

## Ablauf

1. **Begehung und Risikoanalyse** — Standortinspektion, Schädlingsart und Befallsdichte.
2. **Plan und Angebot** — Methode, Produkt, Häufigkeit und Garantie.
3. **Anwendung** — Vor Ort durch zertifizierte Anwender.
4. **Monitoring und Berichterstattung** — Überwachungsstationen und regelmäßige Kontrollen prüfen die Wirksamkeit.

## Sicherheit und Zertifizierung

Für jedes Produkt stellen wir die Biozid-Zulassung des Gesundheitsministeriums, das Sicherheitsdatenblatt (SDS) und den Servicebericht bereit. Eine 2-4-stündige Lüftungsphase nach der Anwendung ist in der Regel ausreichend.

## IPM für Lebensmittelbetriebe

HACCP-konforme IPM-Programme, die bei Zertifizierungsaudits anerkannt werden — für Restaurants, Küchen, Einzelhandel und Lebensmittelproduktion — mit Überwachungsstationen, Trenddiagrammen und monatlicher Berichterstattung.`,
    title_es: "Control de Plagas y Desinfección",
    summary_es: "Servicios de control de plagas autorizados por el Ministerio de Salud con garantía de resultados.",
    content_es: `Nuestros servicios de control de plagas, desinfección y aplicaciones biocidas utilizan productos autorizados por el Ministerio de Salud turco y son realizados por aplicadores certificados. Con un enfoque de Gestión Integrada de Plagas (IPM) ofrecemos resultados duraderos en Estambul y toda Turquía.

## Alcance del Servicio

- Cucarachas, hormigas, moscas, mosquitos
- Ratas y otros roedores (estaciones de seguimiento selladas)
- Garrapatas, polillas y plagas de almacén
- Tratamientos contra chinches de cama
- Desinfección general y control de virus/bacterias
- Aplicaciones ULV en exteriores
- Programas IPM conformes con HACCP para empresas alimentarias

## Proceso

1. **Inspección y análisis de riesgos** — Visita al emplazamiento, tipo de plaga y densidad de infestación.
2. **Plan y propuesta** — Método, producto, frecuencia y garantía.
3. **Aplicación** — In situ, por aplicadores certificados.
4. **Seguimiento e informes** — Estaciones de monitorización y controles periódicos verifican la eficacia.

## Seguridad y Certificación

Para cada producto facilitamos la autorización biocida del Ministerio de Salud, la Ficha de Datos de Seguridad (FDS) y el informe de servicio. Por lo general, un período de ventilación de 2-4 horas tras la aplicación es suficiente.

## IPM para Empresas Alimentarias

Programas IPM conformes con HACCP, aceptados en auditorías de certificación — para restaurantes, cocinas, retail y producción alimentaria — con estaciones de monitorización, gráficos de tendencias e informes mensuales.`,
    title_ru: "Дезинсекция и дезинфекция",
    summary_ru: "Уничтожение вредителей с лицензией Министерства здравоохранения и гарантией результата.",
    content_ru: `Наши услуги по борьбе с вредителями, дезинфекции и биоцидным обработкам применяют средства, лицензированные Министерством здравоохранения Турции, и выполняются сертифицированными специалистами. Благодаря подходу интегрированного управления вредителями (IPM) мы достигаем долговременных результатов в Стамбуле и по всей Турции.

## Спектр услуг

- Тараканы, муравьи, мухи, комары
- Крысы и другие грызуны (герметичные мониторинговые станции)
- Клещи, моль и вредители запасов
- Обработка от постельных клопов
- Общая дезинфекция и контроль вирусов/бактерий
- Наружные ULV-обработки
- Программы IPM, соответствующие HACCP, для пищевых предприятий

## Порядок работы

1. **Обследование и анализ рисков** — Инспекция объекта, определение вида и плотности вредителей.
2. **План и предложение** — Метод, средство, периодичность и гарантия.
3. **Обработка** — На объекте, сертифицированными специалистами.
4. **Мониторинг и отчётность** — Мониторинговые станции и периодические проверки подтверждают эффективность.

## Безопасность и сертификация

По каждому средству мы предоставляем биоцидную лицензию Министерства здравоохранения, паспорт безопасности (MSDS) и акт выполненных работ. Как правило, достаточно 2-4 часов проветривания после обработки.

## IPM для пищевых предприятий

Программы IPM, соответствующие HACCP и признаваемые при сертификационных аудитах, для ресторанов, кухонь, розничных и пищевых производств — с мониторинговыми станциями, графиками тенденций и ежемесячной отчётностью.`,
    title_fr: "Désinsectisation et Désinfection",
    summary_fr: "Services de lutte antiparasitaire agréés par le ministère de la Santé, avec garantie de résultats.",
    content_fr: `Nos services de lutte antiparasitaire, de désinfection et d'applications biocides utilisent des produits agréés par le ministère de la Santé turc et sont réalisés par des applicateurs certifiés. Avec une approche de Gestion Intégrée des Nuisibles (IPM) nous obtenons des résultats durables à Istanbul et dans toute la Turquie.

## Périmètre des Services

- Cafards, fourmis, mouches, moustiques
- Rats et autres rongeurs (stations de surveillance scellées)
- Tiques, mites et nuisibles des stocks
- Traitements contre les punaises de lit
- Désinfection générale et contrôle des virus/bactéries
- Applications ULV en extérieur
- Programmes IPM conformes HACCP pour les entreprises alimentaires

## Processus

1. **Inspection et analyse des risques** — Visite du site, identification de l'espèce et de la densité d'infestation.
2. **Plan et devis** — Méthode, produit, fréquence et garantie.
3. **Application** — Sur place, par des applicateurs certifiés.
4. **Suivi et reporting** — Des stations de surveillance et des contrôles périodiques vérifient l'efficacité.

## Sécurité et Certification

Pour chaque produit, nous fournissons l'autorisation biocide du ministère de la Santé, la Fiche de Données de Sécurité (FDS) et le rapport de service. Une période d'aération de 2-4 heures après l'application est généralement suffisante.

## IPM pour les Entreprises Alimentaires

Programmes IPM conformes HACCP, acceptés lors des audits de certification — pour les restaurants, cuisines, commerces de détail et productions alimentaires — avec stations de surveillance, graphiques de tendances et reporting mensuel.`,
    image_url: null,
  },
  {
    id: "f6",
    slug: "elektronik-guvenlik-sistemleri",
    icon: "Camera",
    title_tr: "Elektronik Güvenlik Sistemleri",
    title_en: "Electronic Security Systems",
    title_it: "Sistemi di Sicurezza Elettronici",
    summary_tr: "Risk analizi, projelendirme, uygulama ve teknik bakım hizmetleri.",
    summary_en: "Risk analysis, design, installation and technical support.",
    summary_it: "Analisi dei rischi, progettazione, installazione e assistenza tecnica.",
    content_tr: `CCTV, geçiş kontrol, alarm, yangın algılama ve plaka tanıma sistemleri için keşiften kuruluma, devreye almadan periyodik bakıma kadar uçtan uca çözümler sunuyoruz. Fiziksel güvenlik personelimizle birlikte entegre güvenlik mimarileri tasarlıyoruz.

## Hizmet Kapsamımız

- IP/CCTV kamera sistemleri (4K, termal, PTZ, AI analitik)
- Geçiş kontrol ve turnike sistemleri (kart, biyometrik, mobil)
- Hırsız alarm sistemleri
- Yangın algılama ve söndürme sistemleri
- Plaka tanıma (LPR) ve otopark yönetimi
- Diafon ve görüntülü interkom
- Kablolama, network ve yapısal altyapı

## Mimari ve Tasarım

Risk analizi → çözüm tasarımı → ürün seçimi → projelendirme → kurulum → devreye alma → eğitim ve devir akışını standart olarak uygularız. Marka bağımsız çalışırız; tesisinize en uygun ve sürdürülebilir teknolojiyi öneriyoruz.

## KVKK ve Mevzuat Uyumu

Kayıt sürelerini KVKK ve sektör mevzuatına (özellikle sağlık, eğitim, kamu) uygun planlıyor; aydınlatma metinleri, açık rıza yönetimi ve veri sahibi başvuru prosedürleri için danışmanlık veriyoruz.

## Bakım ve Destek

Kurulum sonrası 1 yıl garanti ve yıllık periyodik bakım sözleşmeleri sunuyoruz. 7/24 teknik destek hattımız ve uzaktan izleme altyapımız sayesinde arızalara hızlı müdahale ediyoruz.

## Mevcut Sistem Yükseltme

Analog→IP geçişleri, eski kameraların yenilenmesi, kayıt sürelerinin uzatılması ve AI tabanlı analitik (insan/araç algılama, kalabalık takibi, plaka okuma) eklenmesi için kademeli yükseltme planları hazırlıyoruz.`,
    content_en: `End-to-end solutions for CCTV, access control, alarm, fire detection and license-plate recognition — from survey to installation, commissioning and periodic maintenance. We design integrated security architectures alongside our physical security personnel.

## Scope of Service

- IP/CCTV cameras (4K, thermal, PTZ, AI analytics)
- Access control and turnstiles (card, biometric, mobile)
- Intruder alarm systems
- Fire detection and suppression
- License-plate recognition (LPR) and parking management
- Intercom and video door entry
- Cabling, network and structured infrastructure

## Architecture and Design

Risk analysis → solution design → product selection → engineering → installation → commissioning → training and handover. Vendor-neutral — we recommend the technology best suited to your facility.

## KVKK / GDPR Compliance

Retention is aligned with KVKK/GDPR and sector regulation (healthcare, education, public). We advise on privacy notices, consent and data-subject request procedures.

## Maintenance and Support

A 1-year post-installation warranty and annual maintenance contracts, backed by 24/7 technical support and remote monitoring for rapid response.

## System Upgrades

Staged plans for analog→IP migration, camera refresh, longer retention and AI analytics (person/vehicle detection, crowd analytics, LPR).`,
    content_it: `Soluzioni end-to-end per TVCC, controllo accessi, antintrusione, rivelazione incendio e riconoscimento targhe — dal sopralluogo all'installazione, dalla messa in servizio alla manutenzione periodica. Progettiamo architetture di sicurezza integrate insieme al nostro personale di sicurezza fisica.

## Ambito del Servizio

- Telecamere IP/TVCC (4K, termiche, PTZ, analitica AI)
- Controllo accessi e tornelli (card, biometrico, mobile)
- Sistemi antintrusione
- Rivelazione e spegnimento incendio
- Riconoscimento targhe (LPR) e gestione parcheggi
- Citofonia e videocitofonia
- Cablaggio, rete e infrastruttura strutturata

## Architettura e Progettazione

Analisi del rischio → progettazione della soluzione → scelta dei prodotti → ingegnerizzazione → installazione → messa in servizio → formazione e consegna. Siamo vendor-neutral — proponiamo la tecnologia più adatta e sostenibile per la vostra struttura.

## Conformità KVKK / GDPR

I periodi di conservazione sono allineati a KVKK/GDPR e alla normativa di settore (sanità, istruzione, pubblica amministrazione). Forniamo consulenza su informative, consenso e procedure per le richieste degli interessati.

## Manutenzione e Supporto

Garanzia di 1 anno post-installazione e contratti annuali di manutenzione, con supporto tecnico 24/7 e monitoraggio remoto per interventi rapidi.

## Aggiornamento dei Sistemi Esistenti

Piani di aggiornamento graduale per la migrazione analogico→IP, sostituzione delle telecamere, estensione dei tempi di conservazione e analitica AI (rilevamento persone/veicoli, analisi delle folle, LPR).`,
    title_de: "Elektronische Sicherheitssysteme",
    summary_de: "Risikoanalyse, Planung, Installation und technischer Support für elektronische Sicherheitssysteme.",
    content_de: `End-to-End-Lösungen für CCTV, Zugangskontrolle, Einbruchmeldeanlage, Branderkennung und Kennzeichenerkennung — von der Begehung bis zur Installation, von der Inbetriebnahme bis zur regelmäßigen Wartung in Istanbul und der gesamten Türkei. Wir entwerfen integrierte Sicherheitsarchitekturen gemeinsam mit unserem physischen Sicherheitspersonal.

## Leistungsumfang

- IP/CCTV-Kameras (4K, Wärmebildkameras, PTZ, KI-Analytik)
- Zugangskontrolle und Drehkreuze (Karte, biometrisch, mobil)
- Einbruchmeldesysteme
- Brandmelde- und Löschsysteme
- Kennzeichenerkennung (LPR) und Parkverwaltung
- Gegensprechanlage und Videotürsprechanlage
- Verkabelung, Netzwerk und strukturierte Infrastruktur

## Architektur und Design

Risikoanalyse → Lösungsdesign → Produktauswahl → Engineering → Installation → Inbetriebnahme → Schulung und Übergabe. Markenunabhängig — wir empfehlen die für Ihre Einrichtung am besten geeignete und nachhaltigste Technologie.

## DSGVO / KVKK-Konformität

Aufbewahrungsfristen sind auf DSGVO/KVKK und Branchenvorschriften (Gesundheitswesen, Bildung, öffentlicher Bereich) abgestimmt. Wir beraten zu Datenschutzhinweisen, Einwilligungen und Verfahren für Betroffenenanfragen.

## Wartung und Support

1 Jahr Garantie nach der Installation und jährliche Wartungsverträge, unterstützt durch 24/7-technischen Support und Fernüberwachung für schnelle Reaktionen.

## Systemaufrüstungen

Stufenweise Pläne für Analog-zu-IP-Migration, Kameraerneuerung, längere Speicherfristen und KI-Analytik (Personen-/Fahrzeugerkennung, Menschenmengenanalyse, LPR).`,
    title_es: "Sistemas de Seguridad Electrónica",
    summary_es: "Análisis de riesgos, diseño, instalación y soporte técnico para sistemas de seguridad electrónica.",
    content_es: `Soluciones integrales para CCTV, control de accesos, alarmas de intrusión, detección de incendios y reconocimiento de matrículas — desde la inspección hasta la instalación, desde la puesta en marcha hasta el mantenimiento periódico en Estambul y toda Turquía. Diseñamos arquitecturas de seguridad integradas junto con nuestro personal de seguridad física.

## Alcance del Servicio

- Cámaras IP/CCTV (4K, termales, PTZ, analítica IA)
- Control de accesos y torniquetes (tarjeta, biométrico, móvil)
- Sistemas de alarma anti-intrusión
- Detección y extinción de incendios
- Reconocimiento de matrículas (LPR) y gestión de aparcamientos
- Porteros automáticos y videoporteros
- Cableado, red e infraestructura estructurada

## Arquitectura y Diseño

Análisis de riesgos → diseño de solución → selección de productos → ingeniería → instalación → puesta en marcha → formación y entrega. Neutrales en cuanto a marcas — recomendamos la tecnología más adecuada y sostenible para su instalación.

## Cumplimiento GDPR / KVKK

Los períodos de retención están alineados con el GDPR/KVKK y la normativa sectorial (sanidad, educación, sector público). Asesoramos sobre avisos de privacidad, consentimiento y procedimientos para solicitudes de interesados.

## Mantenimiento y Soporte

Garantía de 1 año post-instalación y contratos anuales de mantenimiento, respaldados por soporte técnico 24/7 y monitorización remota para respuesta rápida.

## Actualización de Sistemas Existentes

Planes escalonados para migración analógico→IP, renovación de cámaras, retención ampliada y analítica IA (detección de personas/vehículos, análisis de multitudes, LPR).`,
    title_ru: "Электронные системы безопасности",
    summary_ru: "Анализ рисков, проектирование, монтаж и техническая поддержка систем безопасности.",
    content_ru: `Комплексные решения для CCTV, контроля доступа, охранной и пожарной сигнализации и систем распознавания номерных знаков — от обследования до монтажа, от ввода в эксплуатацию до периодического обслуживания в Стамбуле и по всей Турции. Мы проектируем интегрированные архитектуры безопасности совместно с нашим персоналом физической охраны.

## Спектр услуг

- IP/CCTV-камеры (4K, тепловизионные, PTZ, ИИ-аналитика)
- Контроль доступа и турникеты (карты, биометрия, мобильный)
- Охранно-тревожные системы
- Пожарная сигнализация и пожаротушение
- Системы распознавания номерных знаков (LPR) и управления парковками
- Домофоны и видеодомофоны
- Кабельная разводка, сеть и структурированная инфраструктура

## Архитектура и проектирование

Анализ рисков → разработка решения → подбор оборудования → проектирование → монтаж → ввод в эксплуатацию → обучение и передача. Нейтральность к брендам — рекомендуем технологии, наиболее подходящие для вашего объекта.

## Соответствие GDPR / KVKK

Сроки хранения согласованы с GDPR/KVKK и отраслевыми требованиями (здравоохранение, образование, госсектор). Консультируем по уведомлениям о конфиденциальности, согласиям и процедурам обращения субъектов данных.

## Обслуживание и поддержка

Гарантия 1 год после монтажа и ежегодные договоры обслуживания, подкреплённые круглосуточной технической поддержкой и удалённым мониторингом для оперативного реагирования.

## Модернизация существующих систем

Поэтапные планы перехода аналог→IP, замены камер, расширения сроков хранения и добавления ИИ-аналитики (обнаружение людей/транспорта, анализ толпы, LPR).`,
    title_fr: "Systèmes de Sécurité Électronique",
    summary_fr: "Analyse des risques, conception, installation et support technique pour systèmes de sécurité électronique.",
    content_fr: `Solutions clé en main pour la vidéosurveillance, le contrôle d'accès, les alarmes d'intrusion, la détection incendie et la reconnaissance de plaques — de l'étude à l'installation, de la mise en service à la maintenance périodique à Istanbul et dans toute la Turquie. Nous concevons des architectures de sécurité intégrées en collaboration avec notre personnel de sécurité physique.

## Périmètre des Services

- Caméras IP/CCTV (4K, thermiques, PTZ, analytique IA)
- Contrôle d'accès et tourniquets (carte, biométrique, mobile)
- Systèmes d'alarme anti-intrusion
- Détection et extinction d'incendie
- Reconnaissance de plaques (LPR) et gestion de parkings
- Interphones et visiophonie
- Câblage, réseau et infrastructure structurée

## Architecture et Conception

Analyse des risques → conception de la solution → sélection des produits → ingénierie → installation → mise en service → formation et remise. Vendor-neutral — nous recommandons la technologie la plus adaptée et durable à votre établissement.

## Conformité RGPD / KVKK

Les durées de conservation sont alignées sur le RGPD/KVKK et la réglementation sectorielle (santé, éducation, secteur public). Nous conseillons sur les mentions d'information, le consentement et les procédures de demande des personnes concernées.

## Maintenance et Support

Garantie d'1 an post-installation et contrats annuels de maintenance, avec support technique 24h/24 et surveillance à distance pour une intervention rapide.

## Mises à Niveau des Systèmes Existants

Plans de migration graduelle analogique→IP, renouvellement des caméras, conservation prolongée et analytique IA (détection personnes/véhicules, analyse de foule, LPR).`,
    image_url: null,
  },
];

export function servicePath(slug: string) {
  return `/hizmet/${slug}`;
}

/**
 * Merge DB service rows with local fallbacks by slug, filling any missing
 * locale-specific fields (e.g. title_it / summary_it) from the fallback data.
 * The DB row always wins where it already has a value.
 */
export function mergeServiceFallbacks<T extends Record<string, any>>(list: T[]): T[] {
  return list.map((row) => {
    const fb = fallbackServices.find((f) => f.slug === row.slug);
    if (!fb) return row;
    const merged: any = { ...row };
    for (const key of Object.keys(fb)) {
      if (merged[key] === undefined || merged[key] === null || merged[key] === "") {
        merged[key] = (fb as any)[key];
      }
    }
    return merged as T;
  });
}
